<script setup>
const {t} = useI18n();
const localePath = useLocalePath();
</script>

<template>
	<main class="main">
		<slot/>
	</main>
</template>
